import { Fragment, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { useControlledHotkeys } from '../common/hooks/useControlledHotkeys.js'
import { SmartSearch } from '../SmartSearch/index.js'

import { COMMAND_BAR_HOTKEYS } from './CommandBar.constants.js'
import { CommandBarMode } from './CommandBar.types.js'
import { useCommandBar } from './CommandBarContext.js'
import {
  ActionItemsHotkeys,
  CommandResults,
  HotkeysGuide,
} from './components/index.js'

export const CommandBar = () => {
  const { pathname } = useLocation()
  const { open, close, isOpen, searchOptions } = useCommandBar()

  useControlledHotkeys(
    COMMAND_BAR_HOTKEYS.SEARCH.value,
    e => {
      e.preventDefault()
      if (isOpen && searchOptions.mode === CommandBarMode.SEARCH) {
        close()
      } else {
        open({
          searchOptions: {
            mode: CommandBarMode.SEARCH,
            placeholder: searchOptions.placeholder,
          },
        })
      }
    },
    { enabled: true, enableOnFormTags: true },
  )

  useControlledHotkeys(
    COMMAND_BAR_HOTKEYS.COMMANDS.value,
    e => {
      e.preventDefault()
      if (isOpen && searchOptions.mode === CommandBarMode.COMMANDS) {
        close()
      } else {
        open({ searchOptions: { mode: CommandBarMode.COMMANDS } })
      }
    },
    { enabled: true, enableOnFormTags: true },
  )

  useControlledHotkeys(
    'esc',
    e => {
      e.preventDefault()
      close()
    },
    { enabled: true },
  )

  // this is to close the command bar when the user navigates to a different page using the Link component
  useEffect(() => {
    close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <>
      <ActionItemsHotkeys />
      <Modal
        scrollable={false}
        open={isOpen}
        onClose={close}
        size="2xl"
        className="command-bar-modal [&_*]:tracking-normal"
      >
        <Modal.Content padding={false} className="command-bar-modal-content">
          {searchOptions.mode === CommandBarMode.COMMANDS ? (
            <CommandResults />
          ) : (
            <SmartSearch className="h-screen sm:h-[80vh]" view="command-bar" />
          )}
          <HotkeysGuide />
        </Modal.Content>
      </Modal>
    </>
  )
}
